(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["om-collection-3DCarousel-V2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT = '.om-3d-carousel[data-section-id]';
  const instances = new WeakMap();
  const init = (root) => {
    if (instances.has(root)) return;
    const stage = root.querySelector('[data-om-carousel]');
    const track = root.querySelector('[data-om-carousel-track]');
    const cards = [...root.querySelectorAll('[data-om-carousel-card]')];
    if (!stage || !track || !cards.length) return;
    const dots = [...root.querySelectorAll('[data-om-carousel-dot]')];
    const slideStatus = root.querySelector('[data-om-carousel-status]');
    const cartStatus = root.querySelector('[data-om-cart-status]');
    const fallback = root.querySelector('[data-om-cart-fallback]');
    const rotation = root.querySelector('[data-om-rotation]');
    const mobile = matchMedia('(max-width: 749px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const hover = matchMedia('(hover: hover)');
    const events = new AbortController();
    const timers = new Set();
    const on = (target, name, handler, options = {}) => target?.addEventListener(name, handler, { ...options, signal: events.signal });
    const later = (fn, delay) => {
      const id = setTimeout(() => { timers.delete(id); if (!disposed) fn(); }, delay);
      timers.add(id);
      return id;
    };
    let index = 0, timer = null, busy = false, disposed = false, paused = false;
    let gesture = null, suppressClickUntil = 0, editorSelected = false;
    let cartObserver = null, observedCart = null;
    const cartOpen = () => observedCart && (observedCart.matches('.active, [open]') || observedCart.querySelector('.cart-notification.active, dialog[open]') || observedCart.contains(document.activeElement));
    const stop = () => { clearTimeout(timer); timer = null; };
    const start = () => {
      stop();
      if (disposed || busy || gesture || paused || editorSelected || cartOpen() || cards.length < 2 ||
          stage.dataset.autoplay !== 'true' || reduced.matches || document.hidden ||
          stage.contains(document.activeElement) || (hover.matches && stage.matches(':hover'))) return;
      timer = setTimeout(() => { go(index + 1); start(); }, Math.max(2, Number(stage.dataset.autoplaySpeed) || 5) * 1000);
    };
    const update = () => {
      cards.forEach((card, i) => {
        let delta = i - index;
        if (delta > cards.length / 2) delta -= cards.length;
        if (delta < -cards.length / 2) delta += cards.length;
        const active = delta === 0;
        card.dataset.pos = Math.abs(delta) <= (mobile.matches ? 1 : 2) ? String(delta) : 'hidden';
        card.style.zIndex = String(active ? 50 : card.dataset.pos === 'hidden' ? 0 : 50 - Math.abs(delta) * 10);
        card.setAttribute('aria-hidden', String(!active));
        card.querySelector('.om-3d-carousel__link').tabIndex = active ? 0 : -1;
        const button = card.querySelector('[data-om-quick-add]');
        button.tabIndex = active ? 0 : -1;
        button.disabled = !active || busy || button.dataset.available !== 'true' || button.dataset.uncertain === 'true' || button.dataset.state === 'success';
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const go = (value, announce = false) => {
      if (busy) return;
      const nextIndex = ((value % cards.length) + cards.length) % cards.length;
      if (nextIndex !== index && cards[index].contains(document.activeElement)) stage.focus({ preventScroll: true });
      index = nextIndex;
      update();
      if (announce) slideStatus.textContent = `${cards[index].dataset.label}, producto ${index + 1} de ${cards.length}`;
    };
    const manual = (value) => { go(value, true); start(); };
    const setState = (button, state, label) => {
      button.dataset.state = state;
      button.setAttribute('aria-busy', String(state === 'loading'));
      button.setAttribute('aria-label', label);
      button.title = label;
    };
    const readCart = async () => {
      const response = await fetch(`${root.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('No se pudo actualizar el carrito.');
      return response.json();
    };
    const getAdapter = () => {
      const component = [...document.querySelectorAll('cart-drawer, cart-notification')].find(el =>
        typeof el.getSectionsToRender === 'function' && typeof el.renderContents === 'function');
      if (!component) return null;
      try {
        const sections = component.getSectionsToRender();
        const ids = [...new Set(sections.map(s => s.section || s.id))];
        if (!ids.length || ids.length > 5 || ids.some(id => typeof id !== 'string')) return null;
        return { component, ids };
      } catch { return null; }
    };
    const refreshCart = async (data, adapter, button) => {
      let rendered = false;
      if (adapter && adapter.ids.every(id => typeof data.sections?.[id] === 'string')) {
        try {
          adapter.component.setActiveElement?.(button);
          adapter.component.classList.remove('is-empty');
          await adapter.component.renderContents(data);
          rendered = true;
        } catch { rendered = false; }
      }
      if (!rendered && typeof data.sections?.['cart-icon-bubble'] === 'string') {
        const doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        const target = document.getElementById('cart-icon-bubble');
        const content = doc.querySelector('#cart-icon-bubble') || doc.querySelector('.shopify-section');
        if (target && content) target.innerHTML = content.innerHTML;
      }
      const cart = await readCart();
      if (disposed) return rendered;
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.dataset.cartCount = String(cart.item_count);
        if (!el.children.length) el.textContent = String(cart.item_count);
      });
      root.dispatchEvent(new CustomEvent('om:cart-updated', { bubbles: true, detail: { cart, added: data, source: root.dataset.sectionId } }));
      return rendered;
    };
    const add = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const button = event.currentTarget;
      const card = button.closest('[data-om-carousel-card]');
      if (busy || button.disabled || card.dataset.pos !== '0' || !button.dataset.variantId) return;
      busy = true;
      stop();
      const originalLabel = button.getAttribute('aria-label');
      setState(button, 'loading', `Añadiendo ${card.dataset.label} al carrito`);
      cartStatus.textContent = `Añadiendo ${card.dataset.label}…`;
      fallback.hidden = true;
      update();
      const adapter = getAdapter();
      if (adapter && observedCart !== adapter.component) {
        cartObserver?.disconnect();
        observedCart = adapter.component;
        cartObserver = new MutationObserver(start);
        cartObserver.observe(observedCart, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] });
      }
      const sections = adapter?.ids || (document.getElementById('cart-icon-bubble') ? ['cart-icon-bubble'] : []);
      const payload = { id: button.dataset.variantId, quantity: 1 };
      if (sections.length) { payload.sections = sections; payload.sections_url = window.location.pathname; }
      let added = false;
      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          const message = typeof data.description === 'string' ? data.description : 'No se pudo confirmar la compra rápida.';
          throw new Error(message);
        }
        added = true;
        if (disposed) return;
        let rendered = false;
        try { rendered = await refreshCart(data, adapter, button); } catch { rendered = false; }
        if (disposed) return;
        setState(button, 'success', `${card.dataset.label}: añadido al carrito`);
        cartStatus.textContent = `${card.dataset.label}: botella completa añadida al carrito.${rendered ? '' : ' Puedes revisarla en el carrito.'}`;
        fallback.hidden = rendered;
        later(() => { setState(button, 'idle', originalLabel); update(); }, 2200);
      } catch (error) {
        if (disposed) return;
        button.dataset.uncertain = 'true';
        setState(button, 'error', 'Revisa el carrito antes de volver a añadir');
        cartStatus.textContent = added
          ? 'La botella se añadió. Abre el carrito para comprobar el contenido.'
          : `${error.message || 'No se pudo confirmar la respuesta.'} Revisa el carrito antes de volver a añadir; después recarga la página.`;
        fallback.hidden = false;
        try { await readCart(); } catch { }
      } finally {
        busy = false;
        if (!disposed) { update(); start(); }
      }
    };
    cards.forEach((card, i) => {
      const button = card.querySelector('[data-om-quick-add]');
      on(button, 'click', add);
      on(button, 'pointerdown', event => event.stopPropagation());
      on(card, 'click', event => {
        if (event.target.closest('[data-om-quick-add]')) return;
        if (busy || Date.now() < suppressClickUntil) { event.preventDefault(); return; }
        if (card.dataset.pos !== '0' && card.dataset.pos !== 'hidden') {
          event.preventDefault(); manual(i);
        }
      });
    });
    on(root.querySelector('[data-om-carousel-prev]'), 'click', () => manual(index - 1));
    on(root.querySelector('[data-om-carousel-next]'), 'click', () => manual(index + 1));
    dots.forEach(dot => on(dot, 'click', () => manual(Number(dot.dataset.index))));
    on(track, 'dragstart', event => event.preventDefault());
    on(track, 'pointerdown', event => {
      if (!mobile.matches || busy || !event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, lastY: event.clientY };
      stop();
    });
    on(window, 'pointermove', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      gesture.lastX = event.clientX; gesture.lastY = event.clientY;
    }, { passive: true });
    const endGesture = (event) => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      gesture = null;
      if (event.type !== 'pointercancel' && Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
        suppressClickUntil = Date.now() + 450;
        go(index + (dx < 0 ? 1 : -1), true);
      }
      start();
    };
    on(window, 'pointerup', endGesture);
    on(window, 'pointercancel', endGesture);
    on(window, 'blur', () => { gesture = null; stop(); });
    on(window, 'focus', start);
    on(stage, 'keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      if (event.target.matches('input, textarea, select, [contenteditable="true"]')) return;
      event.preventDefault();
      manual(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : index + (event.key === 'ArrowLeft' ? -1 : 1));
    });
    on(stage, 'mouseenter', () => { if (hover.matches) stop(); });
    on(stage, 'mouseleave', start);
    on(stage, 'focusin', stop);
    on(stage, 'focusout', () => later(start, 0));
    on(document, 'focusin', () => { if (observedCart) start(); });
    on(document, 'focusout', () => { if (observedCart) later(start, 0); });
    on(document, 'visibilitychange', start);
    on(mobile, 'change', () => { gesture = null; update(); start(); });
    on(reduced, 'change', start);
    on(rotation, 'click', () => {
      paused = !paused;
      rotation.setAttribute('aria-pressed', String(paused));
      rotation.setAttribute('aria-label', paused ? 'Reanudar reproducción automática' : 'Pausar reproducción automática');
      rotation.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      start();
    });
    if (rotation) rotation.hidden = cards.length < 2;
    const state = {
      select(value) { editorSelected = value; start(); },
      destroy() { disposed = true; stop(); cartObserver?.disconnect(); timers.forEach(clearTimeout); events.abort(); instances.delete(root); }
    };
    instances.set(root, state);
    update(); start();
  };
  const roots = (container) => [...(container.matches?.(ROOT) ? [container] : []), ...container.querySelectorAll(ROOT)];
  const initAll = () => roots(document).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => roots(event.target).forEach(root => { instances.get(root)?.destroy(); init(root); }));
  document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => instances.get(root)?.destroy()));
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:section:select', event => roots(event.target).forEach(root => instances.get(root)?.select(true)));
  document.addEventListener('shopify:section:deselect', event => roots(event.target).forEach(root => instances.get(root)?.select(false)));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["om-collection-3dcarousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT = '.om-3d-carousel[data-section-id]';
  const instances = new WeakMap();
  let quickAddReady;
  const ensureQuickAdd = () => {
    if (!quickAddReady) quickAddReady = Promise.race([
      customElements.whenDefined('quick-add-component'),
      new Promise((_, reject) => setTimeout(() => reject(new Error('La compra rápida aún no está disponible. Intenta de nuevo.')), 8000))
    ]).then(() => {
      if (!customElements.get('om-carousel-quick-add')) {
        const NativeQuickAdd = customElements.get('quick-add-component');
        customElements.define('om-carousel-quick-add', class extends NativeQuickAdd {
          get productPageUrl() {
            const url = new URL(this.dataset.productUrl, window.location.origin);
            url.searchParams.set('variant', this.dataset.bottleVariantId);
            return url.toString();
          }
        });
      }
    }).catch(error => { quickAddReady = null; throw error; });
    return quickAddReady;
  };
  const init = (root) => {
    if (instances.has(root)) return;
    const stage = root.querySelector('[data-om-carousel]');
    const track = root.querySelector('[data-om-carousel-track]');
    const cards = [...root.querySelectorAll('[data-om-carousel-card]')];
    if (!stage || !track || !cards.length) return;
    const dots = [...root.querySelectorAll('[data-om-carousel-dot]')];
    const slideStatus = root.querySelector('[data-om-carousel-status]');
    const cartStatus = root.querySelector('[data-om-cart-status]');
    const mobile = matchMedia('(max-width: 749px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const hover = matchMedia('(hover: hover)');
    const events = new AbortController();
    const timers = new Set();
    const on = (target, name, handler, options = {}) => target?.addEventListener(name, handler, { ...options, signal: events.signal });
    const later = (fn, delay) => {
      const id = setTimeout(() => { timers.delete(id); if (!disposed) fn(); }, delay);
      timers.add(id);
      return id;
    };
    let index = 0, timer = null, busy = false, disposed = false;
    let gesture = null, suppressClickUntil = 0, editorSelected = false;
    let cartObserver = null, observedCart = null;
    const modalOpen = () => !!document.querySelector('#quick-add-dialog dialog[open], theme-drawer#cart-drawer[open], cart-drawer.active');
    const stop = () => { clearTimeout(timer); timer = null; };
    const start = () => {
      stop();
      if (disposed || busy || gesture || editorSelected || modalOpen() || cards.length < 2 ||
          stage.dataset.autoplay !== 'true' || reduced.matches || document.hidden ||
          stage.contains(document.activeElement) || (hover.matches && stage.matches(':hover'))) return;
      timer = setTimeout(() => { go(index + 1); start(); }, Math.max(2, Number(stage.dataset.autoplaySpeed) || 5) * 1000);
    };
    const update = () => {
      cards.forEach((card, i) => {
        let delta = i - index;
        if (delta > cards.length / 2) delta -= cards.length;
        if (delta < -cards.length / 2) delta += cards.length;
        const active = delta === 0;
        card.dataset.pos = Math.abs(delta) <= (mobile.matches ? 1 : 2) ? String(delta) : 'hidden';
        card.style.zIndex = String(active ? 50 : card.dataset.pos === 'hidden' ? 0 : 50 - Math.abs(delta) * 10);
        card.setAttribute('aria-hidden', String(!active));
        card.querySelector('.om-3d-carousel__link').tabIndex = active ? 0 : -1;
        const button = card.querySelector('[data-om-quick-add]');
        button.tabIndex = active ? 0 : -1;
        button.disabled = !active || busy || button.dataset.available !== 'true';
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const go = (value, announce = false) => {
      if (busy) return;
      const nextIndex = ((value % cards.length) + cards.length) % cards.length;
      if (nextIndex !== index && cards[index].contains(document.activeElement)) stage.focus({ preventScroll: true });
      index = nextIndex;
      update();
      if (announce) slideStatus.textContent = `${cards[index].dataset.label}, producto ${index + 1} de ${cards.length}`;
    };
    const manual = (value) => { go(value, true); start(); };
    const setState = (button, state, label) => {
      button.dataset.state = state;
      button.setAttribute('aria-busy', String(state === 'loading'));
      button.setAttribute('aria-label', label);
      button.title = label;
    };
    const add = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const button = event.currentTarget;
      const card = button.closest('[data-om-carousel-card]');
      if (busy || button.disabled || card.dataset.pos !== '0' || !button.dataset.variantId) return;
      busy = true;
      stop();
      const originalLabel = button.dataset.idleLabel || button.getAttribute('aria-label');
      button.dataset.idleLabel = originalLabel;
      setState(button, 'loading', `Abriendo opciones de ${card.dataset.label}`);
      cartStatus.textContent = `Abriendo opciones de ${card.dataset.label}`;
      update();
      try {
        await ensureQuickAdd();
        if (disposed) return;
        const dialog = document.getElementById('quick-add-dialog');
        const host = button.closest('om-carousel-quick-add');
        if (!dialog || !host || typeof host.handleClick !== 'function') throw new Error('Compra rápida no disponible. Abre el producto desde su imagen.');
        observedCart = document.getElementById('cart-drawer');
        cartObserver?.disconnect();
        cartObserver = new MutationObserver(start);
        cartObserver.observe(dialog, { attributes: true, subtree: true, attributeFilter: ['open'] });
        if (observedCart) cartObserver.observe(observedCart, { attributes: true, attributeFilter: ['open', 'class'] });
        button.disabled = false;
        button.focus({ preventScroll: true });
        await host.handleClick(event);
        if (disposed) return;
        if (!dialog.querySelector('dialog[open]')) throw new Error('No se pudo abrir la compra rápida. Intenta de nuevo.');
        const content = dialog.querySelector('#quick-add-modal-content');
        let selectedVariant;
        try { selectedVariant = JSON.parse(content?.getAttribute('view-event-payload') || '{}').product?.selectedVariant?.id; } catch { }
        if (String(selectedVariant) !== button.dataset.variantId) {
          dialog.closeDialog();
          throw new Error('No se pudo preseleccionar la botella. Abre el producto desde su imagen.');
        }
        setState(button, 'idle', originalLabel);
        cartStatus.textContent = '';
      } catch (error) {
        if (disposed) return;
        setState(button, 'error', error.message || 'No se pudo abrir la compra rápida. Intenta de nuevo.');
        cartStatus.textContent = button.title;
      } finally {
        busy = false;
        if (!disposed) { update(); start(); }
      }
    };
    cards.forEach((card, i) => {
      const button = card.querySelector('[data-om-quick-add]');
      on(button, 'click', add);
      on(button, 'pointerdown', event => event.stopPropagation());
      on(card, 'click', event => {
        if (event.target.closest('[data-om-quick-add]')) return;
        if (busy || Date.now() < suppressClickUntil) { event.preventDefault(); return; }
        if (card.dataset.pos !== '0' && card.dataset.pos !== 'hidden') {
          event.preventDefault(); manual(i);
        }
      });
    });
    on(root.querySelector('[data-om-carousel-prev]'), 'click', () => manual(index - 1));
    on(root.querySelector('[data-om-carousel-next]'), 'click', () => manual(index + 1));
    dots.forEach(dot => on(dot, 'click', () => manual(Number(dot.dataset.index))));
    on(track, 'dragstart', event => event.preventDefault());
    on(track, 'pointerdown', event => {
      if (!mobile.matches || busy || !event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, lastY: event.clientY };
      stop();
    });
    on(window, 'pointermove', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      gesture.lastX = event.clientX; gesture.lastY = event.clientY;
    }, { passive: true });
    const endGesture = (event) => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      gesture = null;
      if (event.type !== 'pointercancel' && Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
        suppressClickUntil = Date.now() + 450;
        go(index + (dx < 0 ? 1 : -1), true);
      }
      start();
    };
    on(window, 'pointerup', endGesture);
    on(window, 'pointercancel', endGesture);
    on(window, 'blur', () => { gesture = null; stop(); });
    on(window, 'focus', start);
    on(stage, 'keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      if (event.target.matches('input, textarea, select, [contenteditable="true"]')) return;
      event.preventDefault();
      manual(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : index + (event.key === 'ArrowLeft' ? -1 : 1));
    });
    on(stage, 'mouseenter', () => { if (hover.matches) stop(); });
    on(stage, 'mouseleave', start);
    on(stage, 'focusin', stop);
    on(stage, 'focusout', () => later(start, 0));
    on(document, 'focusin', () => { start(); });
    on(document, 'focusout', () => { later(start, 0); });
    on(document, 'visibilitychange', start);
    on(mobile, 'change', () => { gesture = null; update(); start(); });
    on(reduced, 'change', start);
    const state = {
      select(value) { editorSelected = value; start(); },
      destroy() { disposed = true; stop(); cartObserver?.disconnect(); timers.forEach(clearTimeout); events.abort(); instances.delete(root); }
    };
    instances.set(root, state);
    update(); start();
  };
  const roots = (container) => [...(container.matches?.(ROOT) ? [container] : []), ...container.querySelectorAll(ROOT)];
  const initAll = () => roots(document).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => roots(event.target).forEach(root => { instances.get(root)?.destroy(); init(root); }));
  document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => instances.get(root)?.destroy()));
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:section:select', event => roots(event.target).forEach(root => instances.get(root)?.select(true)));
  document.addEventListener('shopify:section:deselect', event => roots(event.target).forEach(root => instances.get(root)?.select(false)));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["om-faq-minimal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '.om-faq[data-section-id]';
    const DURATION_OPEN = 560;
    const DURATION_CLOSE = 460;
    const EASING = 'cubic-bezier(.16, 1, .3, 1)';

    const initFaq = (sectionRoot) => {
      if (
        !sectionRoot ||
        sectionRoot.dataset.omFaqInit === 'true'
      ) {
        return;
      }

      const root = sectionRoot.querySelector(
        '[data-om-faq-root]'
      );

      if (!root) return;

      const items = Array.from(
        root.querySelectorAll(
          'details[data-om-faq-item]'
        )
      );

      if (!items.length) return;

      sectionRoot.dataset.omFaqInit = 'true';
      sectionRoot.dataset.omFaqEnhanced = 'true';

      const controller = new AbortController();
      const { signal } = controller;

      const motionQuery = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      const singleOpen =
        root.dataset.singleOpen === 'true';

      const animations = new WeakMap();

      const getAnswer = (details) =>
        details.querySelector('.om-faq__answer');

      const cancelAnimation = (answer) => {
        const currentAnimation =
          animations.get(answer);

        if (currentAnimation) {
          currentAnimation.cancel();
        }

        animations.delete(answer);
      };

      const setHeight = (details) => {
        const answer = getAnswer(details);

        if (!answer) return;

        answer.style.height = details.open
          ? `${answer.scrollHeight}px`
          : '0px';
      };

      const animateHeight = (
        answer,
        from,
        to,
        duration,
        onFinish
      ) => {
        cancelAnimation(answer);

        if (
          motionQuery.matches ||
          typeof answer.animate !== 'function'
        ) {
          answer.style.height = `${to}px`;
          onFinish?.();
          return;
        }

        answer.style.height = `${to}px`;

        const animation = answer.animate(
          [
            { height: `${from}px` },
            { height: `${to}px` }
          ],
          {
            duration,
            easing: EASING
          }
        );

        animations.set(answer, animation);

        animation.onfinish = () => {
          if (animations.get(answer) !== animation) {
            return;
          }

          animations.delete(answer);
          onFinish?.();
        };

        animation.oncancel = () => {
          if (animations.get(answer) === animation) {
            animations.delete(answer);
          }
        };
      };

      const openDetails = (details) => {
        const answer = getAnswer(details);

        if (!answer) return;

        details.classList.remove('is-closing');

        const from =
          answer.getBoundingClientRect().height;

        details.open = true;

        const to = answer.scrollHeight;

        animateHeight(
          answer,
          from,
          to,
          DURATION_OPEN,
          () => {
            if (details.open) {
              answer.style.height =
                `${answer.scrollHeight}px`;
            }
          }
        );
      };

      const closeDetails = (details) => {
        const answer = getAnswer(details);

        if (!answer) return;

        details.classList.add('is-closing');

        const from =
          answer.getBoundingClientRect().height;

        animateHeight(
          answer,
          from,
          0,
          DURATION_CLOSE,
          () => {
            details.open = false;
            details.classList.remove('is-closing');
            answer.style.height = '0px';
          }
        );
      };

      const closeOtherItems = (current) => {
        if (!singleOpen) return;

        items.forEach((item) => {
          if (
            item !== current &&
            item.open
          ) {
            closeDetails(item);
          }
        });
      };

      items.forEach((details) => {
        setHeight(details);

        const summary =
          details.querySelector('summary');

        if (!summary) return;

        summary.addEventListener(
          'click',
          (event) => {
            event.preventDefault();

            if (details.open) {
              closeDetails(details);
            } else {
              closeOtherItems(details);
              openDetails(details);
            }
          },
          { signal }
        );
      });

      const syncOpenHeights = () => {
        items.forEach((details) => {
          if (!details.open) return;

          const answer = getAnswer(details);

          if (
            !answer ||
            animations.has(answer)
          ) {
            return;
          }

          answer.style.height =
            `${answer.scrollHeight}px`;
        });
      };

      let resizeObserver = null;

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(
          syncOpenHeights
        );

        resizeObserver.observe(root);
      } else {
        window.addEventListener(
          'resize',
          syncOpenHeights,
          { signal }
        );
      }

      motionQuery.addEventListener?.(
        'change',
        syncOpenHeights,
        { signal }
      );

      sectionRoot.omFaqCleanup = () => {
        controller.abort();
        resizeObserver?.disconnect();

        items.forEach((details) => {
          const answer = getAnswer(details);

          if (answer) {
            cancelAnimation(answer);
            answer.style.removeProperty('height');
          }

          details.classList.remove('is-closing');
        });

        delete sectionRoot.dataset.omFaqInit;
        delete sectionRoot.dataset.omFaqEnhanced;
        delete sectionRoot.omFaqCleanup;
      };
    };

    const initAll = () => {
      document
        .querySelectorAll(ROOT_SELECTOR)
        .forEach(initFaq);
    };

    initAll();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        const sectionRoot =
          event.target?.querySelector?.(
            ROOT_SELECTOR
          );

        initFaq(sectionRoot);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        const sectionRoot =
          event.target?.querySelector?.(
            ROOT_SELECTOR
          );

        sectionRoot?.omFaqCleanup?.();
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
